import { appendOperationalEvent } from './eventStore'

export const EVENT_TYPES = {
  login: 'login',
  logout: 'logout',
  operacaoCriada: 'operacao_criada',
  operacaoAtualizada: 'operacao_atualizada',
  checklistConcluido: 'checklist_concluido',
  checklistPendente: 'checklist_pendente',
  itemRetirado: 'item_retirado',
  itemDevolvido: 'item_devolvido',
  itemManutencao: 'item_manutencao',
  uploadRealizado: 'upload_realizado',
  sincronizacaoIniciada: 'sincronizacao_iniciada',
  sincronizacaoConcluida: 'sincronizacao_concluida',
  sincronizacaoErro: 'sincronizacao_erro',
} as const

export type EventType = typeof EVENT_TYPES[keyof typeof EVENT_TYPES]

export interface OperationalEvent {
  id: string
  type: EventType
  operadoraId?: string | null
  operacaoId?: string | null
  userId?: string | null
  createdAt: string
  payload?: Record<string, unknown>
}

export function createOperationalEvent(params: {
  type: EventType
  operadoraId?: string | null
  operacaoId?: string | null
  userId?: string | null
  payload?: Record<string, unknown>
}): OperationalEvent {
  const event: OperationalEvent = {
    id: createEventId(),
    type: params.type,
    operadoraId: params.operadoraId || null,
    operacaoId: params.operacaoId || null,
    userId: params.userId || null,
    payload: params.payload || {},
    createdAt: new Date().toISOString(),
  }

  appendOperationalEvent(event)

  return event
}

function createEventId() {
  if ('crypto' in window && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }

  return `event-${Date.now()}-${Math.random().toString(36).slice(2)}`
}
